const article = {
	slug: "software-supply-chain-risk",
	title: "Software Supply Chain Risk Is a Judgment Problem",
	date: "1 July 2026",
	updated: null,
	description:
		"Most commercial codebases carry known vulnerabilities in open-source code the team never wrote. In a regulated industry, that is a business risk with an audit date attached, and the hard part is deciding which findings can actually reach production.",
	keywords: [
		"software supply chain",
		"open source security",
		"vulnerability management",
		"regulated industries",
		"engineering leadership",
		"SCA",
	],
	tldr: "86% of commercial codebases carry known vulnerabilities, mostly in open-source code the team never wrote. Counting the problems is not progress. The leadership job is deciding which can actually reach what you ship.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, July 2026.",
	provenanceUrl: null,
	series: "ai-governance-for-finserv-leaders",
	artifact: null,
	markdown: `Some truths about software risk land better when someone says them out loud to a room of people who own the problem.

Here is one that engineering and technology leaders already suspect.

## The number

86% of commercial codebases carry known vulnerabilities, most of them in open-source code the team never wrote. (Black Duck 2025 OSSRA)

In a regulated industry, that is not a security stat. It is a business risk with an audit date attached.

## Counting is not progress

What teams do with that number matters more than the number itself. Most count the problems and call it progress. The best ask a sharper question: which of these can actually reach what we ship, and which are just noise?

That is not a tooling problem. It is a judgment problem, and judgment is a leadership job.

## The hard part is rarely the building

Fifteen years in financial services taught me that the hard part of engineering is rarely the building. It is catching the risk early and getting people with real authority to care before it turns into a headline.

Fix everything and you burn people out. Fix nothing and it shows up at the worst possible time. The job is deciding what sits in between.

Part of what I do is match the right technology to the right room, and the right problem to the people who can act on it.

Source if you want it, Black Duck's 2025 OSSRA: [blackduck.com](https://www.blackduck.com/resources/analyst-reports/open-source-security-risk-analysis.html)`,
};

export default article;
